import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import User from 'models/user/user.model';
import { AppService } from 'services/app/app.service';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';
import { UserService } from 'services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public user: User = new User();
  public showRouterOutlet = false;
  public isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay(),
    );
  
  private userServiceSubscription: Subscription;

  constructor(
    public appService: AppService,
    public arcgisMapService: ArcgisMapService,
    private breakpointObserver: BreakpointObserver,
    public userService: UserService,
  ) { }

  async ngOnInit() {
    await this.appService.init();
    await this.arcgisMapService.init();
    this.userServiceSubscription = this.userService.getCurrentUser().subscribe((usr: User) => this.user = usr);
    this.showRouterOutlet = true;
  }

  logout() {
    this.appService.logout();
  }

  ngOnDestroy() {
    if (this.userServiceSubscription) {
      this.userServiceSubscription.unsubscribe();
    }
  }
}
